import React from "react";
import { Handle, Position } from "@xyflow/react";
import { getNodeRegistryEntry } from "../nodeRegistry";

function ConditionalNode({ data, selected }) {
    const iconKey = data.icon || "if";
    const entry = getNodeRegistryEntry(iconKey);
    const Icon = entry.icon;
    const borderClass = selected
        ? "border-blue-500 shadow-[0_0_12px_rgba(59,130,246,0.15)]"
        : "border-gray-200 hover:border-gray-300";

    const outputs = data.outputs || ["true", "false"];

    return (
        <div
            className={`bg-white rounded-lg border ${borderClass} px-3 py-2 min-w-[220px] max-w-[220px] cursor-pointer transition-all duration-200 shadow-sm`}
        >
            <Handle type="target" position={Position.Left} className="!bg-gray-300 !w-2 !h-2 !border-0" />
            <div className="flex items-center gap-2">
                <div
                    className="w-7 h-7 rounded flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: entry.color + "15" }}
                >
                    <Icon size={15} style={{ color: entry.color }} />
                </div>
                <div className="min-w-0 flex-1">
                    <div className="text-xs font-medium text-gray-900 truncate">
                        {data.title || data.label || "Condition"}
                    </div>
                    {data.subtitle && (
                        <div className="text-[10px] text-gray-500 truncate">{data.subtitle}</div>
                    )}
                </div>
            </div>
            {outputs.map((output, i) => (
                <Handle
                    key={output}
                    type="source"
                    position={Position.Right}
                    id={output}
                    className="!bg-gray-300 !w-2 !h-2 !border-0"
                    style={{ top: `${((i + 1) / (outputs.length + 1)) * 100}%` }}
                />
            ))}
        </div>
    );
}

export default React.memo(ConditionalNode);
